export enum DuaDocumentStatusEnum {
    No_Status_Yet = 0,
    Waiting_For_Researcher_Acknowledgement = 1,
    Waiting_For_IO_Contact = 2,
    Waiting_For_IO_Signature = 3,
    Waiver_In_Negotiation = 4,
    DUA_Ready_Waiting_For_Request_Approval = 5,
    Executed = 6,
}
